import type { NavigateFunction } from 'react-router-dom'
import type { QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { EarmarkWarning } from '@/api/personalLoans'
import { PERSONAL_LOAN_QUERY_KEYS } from '@/lib/personalLoans'
import { ROUTES } from '@/routes/routes'

export const LABEL_CLS = 'block text-sm font-medium text-[var(--fl-text-1)] mb-1'

export function invalidateAfterLoanWrite(queryClient: QueryClient) {
  for (const key of PERSONAL_LOAN_QUERY_KEYS) queryClient.invalidateQueries({ queryKey: [key] })
}

export function warnIfEarmarkShort(
  warning: EarmarkWarning | null | undefined,
  format: (n: number) => string,
  navigate: NavigateFunction
) {
  if (!warning) return
  const goal = warning.goals[0]
  toast.warning(`${goal.name} is now short by ${format(warning.shortfall)}`, {
    action: { label: 'View goal', onClick: () => navigate(ROUTES.APP.GOAL_DETAIL(goal.id)) },
  })
}

export function errorDetail(err: unknown, fallback: string): string {
  return (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail ?? fallback
}

/** Integer paise from a typed amount; null when blank or not a number. */
export function parsePaise(text: string): number | null {
  const trimmed = text.trim()
  if (!trimmed) return null
  const n = Number(trimmed)
  return Number.isNaN(n) ? null : Math.round(n * 100)
}
